import { SECONDS_IN_DAY } from './time'

export enum ChartInterval {
  OneDay = 'OneDay',
  ThreeDays = 'ThreeDays',
  OneWeek = 'OneWeek',
  TwoWeeks = 'TwoWeeks',
  OneMonth = 'OneMonth',
  ThreeMonths = 'ThreeMonths',
  SixMonths = 'SixMonths',
  OneYear = 'OneYear',
  AllTime = 'AllTime',
}

export enum FundingChartAggregatePeriod {
  OneHour = 'OneHour',
  EightHours = 'EightHours',
  OneYear = 'OneYear',
}

export type PerpsDataChartType = 'price' | 'funding'

export const FUNDING_START_TIMESTAMP_MAX_MILLISECONDS = 4 * SECONDS_IN_DAY * 1000
